import { Alert, Button } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

export interface ErrorPaneProps {
  message: string
  onRetry: () => void
}

export default function ErrorPane({ message, onRetry }: ErrorPaneProps) {
  const { formatMessage } = useIntl()

  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" onClick={onRetry}>
          {formatMessage({ id: 'avatarStudio.error.retry' })}
        </Button>
      }
    >
      {message}
    </Alert>
  )
}
